<template>
  <div class="ui form" ref="form">
    <div class="ui pointing secondary menu">
      <a class="item active" data-tab="general">
        <i class="info icon"></i>
        {{ $t("general") }}
      </a>
      <a class="item" data-tab="listeners">
        <i class="code icon"></i>
        {{ $t("listeners") }}
      </a>
      <a class="item" data-tab="notifications">
        <i class="alert sign icon"></i>
        {{ $t("notifications") }}
      </a>
    </div>
    <div class="ui bottom attached tab segment active" data-tab="general">
      <div class="field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="name" v-model="setup.name" />
      </div>
      <div class="field">
        <label for>{{ $t("public key") }}</label>
        <div class="ui action input">
          <textarea name="public_key" rows="2" v-model="setup.public_key"></textarea>
          <button class="ui blue icon button" :data-tooltip="$t('test key')" @click="test_key">
            <i class="bolt icon"></i>
          </button>
        </div>
      </div>
      <div class="field">
        <label for>{{ $t("start element") }}</label>
        <div class="ui selection dropdown" name="start_element" ref="start_element_dropdown">
          <input type="hidden" name="start_element" />
          <i class="dropdown icon"></i>
          <div class="default text">{{ $t("start element") }}</div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="field">
        <div class="ui toggle checkbox">
          <input type="checkbox" name="wait_to_finish" v-model="setup.wait_to_finish" />
          <label>{{ $t("wait for process to finish") }}</label>
        </div>
      </div>
      <div class="ui info message" style="display: block" v-if="start_arguments.length > 0">
        <div class="header">{{ $t("element arguments") }}</div>
        <ul class="list">
          <li v-for="(arg, idx) in start_arguments" :key="idx">{{ arg.name }}</li>
        </ul>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="listeners">
      <div class="ui info message" style="display: block">
        <div class="header">{{ $t("hints") }}</div>
        <ul class="list">
          <li v-html="$t('use P to refer parameters')"></li>
          <li v-html="$t('use D to refer data objects')"></li>
          <li v-html="$t('use T to refer task data')"></li>
        </ul>
      </div>
      <div class="field">
        <label for>{{ $t("on before send") }}</label>
        <editor
          @init="init_editor('javascript')"
          v-model="setup.listeners.on_before_send"
          lang="javascript"
          theme="monokai"
        ></editor>
      </div>
      <div class="field">
        <label for>{{ $t("on receive") }}</label>
        <editor
          @init="init_editor('javascript')"
          v-model="setup.listeners.on_receive"
          lang="javascript"
          theme="monokai"
        ></editor>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="notifications">
      <notifications-manager :events="events" :notifications="setup.notifications" />
    </div>
    <button class="ui green labeled icon fluid button" type="button" @click="ok">
      <i class="ui check icon"></i>
      {{ $t("ok") }}
    </button>
    <div class="ui error message"></div>
  </div>
</template>

<script>
import Editor from "vue2-ace-editor";
import { clone, local_api, error_toast } from "@/utils";
import NotificationsManager from "../NotificationsManager";
import _ from "lodash";

export default {
  name: "SubProcessElementSidebar",
  components: { Editor, NotificationsManager },
  data() {
    return {
      setup: {
        name: "",
        public_key: "",
        start_element: {
          name: "",
          id: ""
        },
        wait_to_finish: "",
        listeners: {
          on_before_send: "",
          on_receive: ""
        },
        notifications: []
      },
      events: [
        { display: this.$t("end"), value: "end" },
        { display: this.$t("start"), value: "start" }
      ],
      start_arguments: [],
      form: undefined
    };
  },
  props: { process: Object, element: Object, project: Object },
  mounted() {
    let vm = this;
    window
      .jQuery(vm.$el)
      .find(".pointing.menu .item")
      .tab();

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
        public_key: ["empty"],
        start_element: ["empty"]
      }
    });

    let conf = vm.$props.element.ngine_configuration;
    if (!_.isEmpty(conf)) {
      vm.setup = clone(conf);

      window
        .jQuery(vm.$refs.start_element_dropdown)
        .dropdown("setup menu", {
          values: [
            {
              name: vm.setup.start_element.name,
              value: vm.setup.start_element.id
            }
          ]
        })
        .dropdown("set selected", vm.setup.start_element.id);

      vm.setup.notifications = vm.setup.notifications || [];
    }
  },
  methods: {
    ok() {
      let isValid = this.form.form("validate form");

      if (isValid) {
        this.$emit("ok", this.setup);
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    init_editor(type) {
      require(`brace/mode/${type}`);
      require("brace/theme/monokai");
    },
    test_key() {
      let vm = this;
      vm.arguments = [];
      local_api(vm, "post", "/ngine_composer/process/do-test-key", {
        k: vm.setup.public_key
      })
        .then(start_events => {
          if (start_events) {
            let vls = start_events.map(s => {
              return { value: s.id, name: s.name };
            });
            window
              .jQuery(vm.$refs.start_element_dropdown)
              .dropdown("clear")
              .dropdown("setup menu", { values: vls })
              .dropdown({
                onChange: function(value, text) {
                  if (
                    ["string", "undefined"].includes(
                      typeof vm.setup.start_element
                    )
                  )
                    vm.setup.start_element = {};
                  vm.setup.start_element.id = value;
                  vm.setup.start_element.name = text;

                  let evt = start_events.find(e => e.id == value);
                  vm.start_arguments = evt
                    ? evt.ngine_configuration.arguments
                    : [];
                }
              })
              .dropdown("show");
          }
        })
        .catch(err => {
          error_toast(err);
        });
    }
  },
  computed: {}
};
</script>

<style>
.hidden {
  display: none !important;
}
</style>
